import { render, staticRenderFns } from "./BookDescription.vue?vue&type=template&id=71f212dc&"
import script from "./BookDescription.vue?vue&type=script&lang=js&"
export * from "./BookDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Purchase: require('/Users/eralpsoftwareweb/Desktop/Active Projects/Heocademy/Gökçe Özel/gokce-ozel-nuxt/components/Purchase/index.vue').default})
